export default {
    services: 'Services',
    portfolio: 'Portfolio',
    clients: 'Clients',
    contact: 'Contact'
}
